import { render } from "./AdminInvoices.vue?vue&type=template&id=2dd6f7ca"
import script from "./AdminInvoices.vue?vue&type=script&lang=js"
export * from "./AdminInvoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__